import axios from 'axios';
import moment from 'moment';
import { all, call, cancel, fork, put, select, take, takeLatest } from "redux-saga/effects";
import { decryptData, encryptData, getAppsetting, getJsonStringfy, getReaderRetriveInterval, getReaderUrl, getStaticAppoinments, gettranId, parseJsonData, serviceConsumerWithOutHeaders } from "../../helpers/helpersIndex";
import { IkioskManager, IKioskModel, IMenus } from "../../models/kioskModel";
import * as actions from './actions';
import * as types from './actionTypes';

const KIOSKMODULE = 'QK1';
const kioskComponent = "Kiosk";

function* getMenusDataAfterLanguageSelection(action) {
    let tranId = gettranId(KIOSKMODULE);
    console.log(`${tranId}_getMenusDataAfterLanguageSelection_Start => `, action);
    const menuTData = ((yield select())['kioskReducer'] as IKioskModel)?.menusTData;
    const kioskType = ((yield select())['kioskReducer'] as IKioskModel)?.kioskType;
    let menusData: IMenus[] | undefined;
    let language: string = action.payload;
    try {
        console.log(`${tranId}_getMenusDataAfterLanguageSelection_End => `, { kioskType, language, menusData, menuTData });
        yield put(actions.setLanguageResponse(language));
    }

    catch (error) {
        // navigate to 403
        console.log(`${tranId}_getMenusDataAfterLanguageSelection_catch => `, error);
        yield put(actions.setLanguageResponse(language));
    }
}


function* setBackActionRequest() {
    let tranId = gettranId(KIOSKMODULE);
    console.log(`${tranId}_setBackActionRequest_Start => `,);
    let kioskModel = (yield select())['kioskReducer'] as IKioskModel;
    let currentSelectedArea = kioskModel?.selectedArea;
    let previousSelected;
    let clearEmiratesData = false;
    console.log("currentSelectedArea", currentSelectedArea, kioskModel)
    try {
        if (currentSelectedArea == IkioskManager.EMIRADESVERIFICATION) {
            previousSelected = IkioskManager.PATIENTJOUNEYEXPLORE;
        }
        else if (currentSelectedArea === IkioskManager.MRNVERIFICATION) {
            previousSelected = IkioskManager.EMIRADESVERIFICATION;
        }
        else if (currentSelectedArea === IkioskManager.APPOINTMENTSAREA) {
            previousSelected = IkioskManager.PATIENTJOUNEYEXPLORE;
            clearEmiratesData = true;
        }
        else if (currentSelectedArea === IkioskManager.TOKENAREA) {
            previousSelected = IkioskManager.APPOINTMENTSAREA;
        }
        else if (currentSelectedArea === IkioskManager.EXISTPATIENTJOUNEYPAGE) {
            previousSelected = IkioskManager.PATIENTJOUNEYEXPLORE;
        }
    }
    catch (error) {
        console.log(`${tranId}setBackActionRequest_Catch => `, error);
    }
    console.log(`${tranId}_setBackActionRequest_End => `, previousSelected);
    yield put(actions.backActionResponse(previousSelected, clearEmiratesData))
}

function* getAppointmentsOnKiosk(tranId) {
    console.log(`${tranId}_getAppointmentsOnKiosk_Start => `, tranId);
    let appointmentsData;
    let errorMessage;
    const currentSelectedArea = IkioskManager.APPOINTMENTSAREA
    appointmentsData = [...getStaticAppoinments()];
    console.log(`${tranId}_getAppointmentsOnKiosk_Api_end==>`, appointmentsData, errorMessage);
    yield put(actions.appointmentsAreaResponse(appointmentsData, currentSelectedArea, errorMessage));
}

function* appointmentsCheckinRequest(action) {
    let tranId = gettranId(KIOSKMODULE);
    console.log(`${tranId}_appointmentsCheckinRequest_Start => `, action);
    let selectedArea: number = (yield select())['kioskReducer']?.selectedArea;
    let tokenTemplate;
    let templatesData;
    let tokenNo;
    let mrnNo;
    let errorMessage;
    let kioskTemplate;
    const response = getStaticAppoinments()?.[0]?.AppointmentCheckIn;
    const tokenPrefix = getStaticAppoinments()?.[0]?.tokenNumberPrefix
    console.log(`${tranId}_appointmentsCheckinRequest_response => `, response, tokenPrefix);

    try {
        const currentTime = moment(new Date()).format('YYYY-MM-DD');
        const tokenData: any = parseJsonData(decryptData(localStorage.getItem("tokenData")) || "{}");
        console.log("currentTime", { currentTime, tokenData, a: tokenData?.[currentTime] });
        localStorage.setItem("tokenData", encryptData(getJsonStringfy({ ...tokenData, [currentTime]: tokenData?.[currentTime] ? tokenData?.[currentTime] + 1 : 1 })));
        console.log(`${tranId}_appointmentsCheckinRequest_Response => `, localStorage);
        tokenNo = tokenPrefix + (tokenData?.[currentTime] || 0);
        mrnNo = response.mrnNo;
        const TemplateReplace = (response?.tokenTemplate as string)?.replace("{currentTime}", moment(new Date()).format("HH:MM:SS")).replace("{appointTime}", moment(new Date()).format("HH:MM:SS")).replace("{Date}", moment(new Date()).format("YYYY-MM-DD")).replace("{tokenNO}", tokenNo);
        templatesData = (TemplateReplace as string)?.split('{barcode}');
        selectedArea = IkioskManager.TOKENAREA;
        tokenTemplate = response?.kioskTemplate;
    }
    catch (error) {
        console.error(`${tranId}_appointmentsCheckinRequest_error => `, error);
        console.log(`${tranId}_appointmentsCheckinRequest_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_appointmentsCheckinRequest_End => `, selectedArea, tokenNo, mrnNo, tokenTemplate, errorMessage);
    yield put(actions.appointmentsCheckinResponse(selectedArea, tokenNo, mrnNo, tokenTemplate, templatesData, errorMessage));
}


function* getEmiratesIdRequest(action) {
    let tranId = gettranId(KIOSKMODULE);
    console.log(`${tranId}_getEmiratesIdRequest_Start => `, action);
    // console.log("checkDob==>", isDobauth);
    let errorMessage: string | undefined;
    let emiratesData;
    let mrnNo;
    let url = getReaderUrl();
    let i = 0;
    let loopInterval = getReaderRetriveInterval() ? getReaderRetriveInterval() : 3;
    while (i < loopInterval) {
        errorMessage = undefined;
        try {
            console.log(`${tranId}_getEmiratesIdRequest_Api_Request => `, i);
            const response = yield call(serviceConsumerWithOutHeaders, url);
            // let response = { status: true, emratesId: "2349879" }
            console.log(`${tranId}_getEmiratesIdRequest_Api_Response => `, response);
            if (response?.status) {
                i = loopInterval;
                emiratesData = response;
                yield call(getAppointmentsOnKiosk, tranId);
            }
            else
                i++;
        } catch (error) {
            console.error(`${tranId}_getEmiratesIdRequest_error => `, error);
            console.log(`${tranId}_getEmiratesIdRequest_catch => `, error);
            i++;
            errorMessage = 'EM4';
        }
    }
    console.log(`${tranId}_getEmiratesIdRequest_End => `, emiratesData, mrnNo, errorMessage);
    yield put(actions.getEmiratesIdResponse(emiratesData, mrnNo, errorMessage));
}

function* getPrintTokenData(action) {
    let tranId = gettranId(KIOSKMODULE);
    let tokenData = action?.payload?.templatesData;
    const tokenNO = action?.payload?.tokenNO
    console.log(`${tranId}_getPrintTokenData_start==>`, { tranId, tokenData })
    const replacePrintToken = tokenData;
    replacePrintToken.date = moment(new Date()).format("YYYY-MM-DD");
    replacePrintToken.tokenNO = tokenNO;
    replacePrintToken.timeNow = moment(new Date()).format("HH:MM:SS");
    replacePrintToken.appointmentTime = moment(new Date()).format("HH:MM:SS");
    const tokenDataTem = tokenData ? replacePrintToken : "";
    let errorMessage1;
    let response1: any;
    try {
        console.log(`${tranId}_getPrintTokenData_request==>`, { replacePrintToken, tokenDataTem, tokenNO })
        response1 = yield axios.post(getAppsetting().printerUrl, tokenDataTem);
        console.log(`${tranId}_getPrintTokenData_response==>`, { response1, tokenData })
        // if (response1?.status) {
        //     errorMessage1 = response1.message ? response1.message : "EM6"
        // }
        // else {
        //     errorMessage1 = response1.message ? response1.message : "EM6"
        // }
    }
    catch (err) {
        errorMessage1 = "";
    }
    yield put(actions.printTokenResponse(errorMessage1));
    return { errorMessage1, response1 }
}



function* kioskWatcher() {
    while (true) {
        const t1 = yield takeLatest(types.SET_LANGUAGE_REQUEST, getMenusDataAfterLanguageSelection);
        const t2 = yield takeLatest(types.BACK_ACTION_REQUEST, setBackActionRequest);
        const t3 = yield takeLatest(types.APPOINTMENT_CHECKEIN_REQUEST, appointmentsCheckinRequest);
        const t4 = yield takeLatest(types.GET_EMIRATES_ID_REQUEST, getEmiratesIdRequest);
        const t5 = yield takeLatest(types.MRN_SUBMIT_REQUEST, getAppointmentsOnKiosk);
        const t6 = yield takeLatest(types.PRINT_TOKEN_REQUEST, getPrintTokenData);
        yield take(types.CANCEL_ALL_PENDING_REQUESTS);
        yield cancel([t1, t2, t3, t4, t5, t6]);
    }
}

function* kioskSaga() {
    yield all([fork(kioskWatcher)]);
}
export default kioskSaga;
